// extracted by mini-css-extract-plugin
export default {"container":"StatsRowRankAndUserInfo_container__OQ2BT"};